import { ComponentView, DelegatedObservableArrayChangeListenner, ObservableArray, View, ViewGenerator, ViewModel } from "binder"
import { MultiSelectComboBoxViewModel } from "./multiSelectComboBox-viewModel"
import { stringIsNullOrEmpty } from "src/common/utilities";

export class MultiSelectComboBoxView extends ComponentView<MultiSelectComboBoxViewModel>{

    private static activeCombos : {select2Element:any,htmlElement:HTMLElement}[] = [];
    private static isStarted : boolean=false;

    GetViewUniqueId(): string {
        return "V-7293EB83-29C5-4A35-B35B-9353AB0AB45F"
    }
    loadHtml(): string {
        let element = require('./multiSelectComboBox.html').default;
        let style = require('./multiSelectComboBox.less');
        return element;
    }
    constructor() {
        super();
        if(MultiSelectComboBoxView.isStarted==false){
            MultiSelectComboBoxView.isStarted = true;
            MultiSelectComboBoxView.startCheckingToDestroy();
        }
    }
    static startCheckingToDestroy(){
        let activeOnes = MultiSelectComboBoxView.activeCombos.filter(x=>x.htmlElement.isConnected==true);
        let notActiveOnes = MultiSelectComboBoxView.activeCombos.filter(x=>x.htmlElement.isConnected==false);
        MultiSelectComboBoxView.activeCombos = activeOnes;

        notActiveOnes.forEach(x=>{
            MultiSelectComboBoxView.destroy(x.select2Element);
        });
        setTimeout(()=>MultiSelectComboBoxView.startCheckingToDestroy(),10000);
    }
    private _itemsChangeHandler : DelegatedObservableArrayChangeListenner;
    private _selectedItemsChangeHandler : DelegatedObservableArrayChangeListenner;
    public set items(v: ObservableArray<ViewModel>) { 
        if(this._items){
            this._items.removeChangeListenner(this._itemsChangeHandler);
        }
        this._items = v;
        if(this._items){
            this._itemsChangeHandler = new DelegatedObservableArrayChangeListenner(this,()=>this.itemsChanged());
            this._items.addChangeListenner(this._itemsChangeHandler);
            this.itemsChanged();
            this.selecteditemsChanged();
        }
    } public get items(): ObservableArray<ViewModel> { return this._items;} private _items: ObservableArray<ViewModel>;
    public set selecteditems(v: ObservableArray<ViewModel>) { 
        if(this._selecteditems){
            this._selecteditems.removeChangeListenner(this._selectedItemsChangeHandler);
        }
        this._selecteditems = v; 
        if(this._selecteditems){
            this._selectedItemsChangeHandler = new DelegatedObservableArrayChangeListenner(this,()=>this.selecteditemsChanged());
            this._selecteditems.addChangeListenner(this._selectedItemsChangeHandler);
            this.selecteditemsChanged();
        }
    } public get selecteditems(): ObservableArray<ViewModel> { return this._selecteditems;} private _selecteditems: ObservableArray<ViewModel>;
    public set searchpath(v: string) { 
        if(this._searchpath!=v){
            this._searchpath = v; 
            this.itemsChanged();
        }
    
    } public get searchpath(): string { return this._searchpath;} private _searchpath: string;
    
    private _selectElement : HTMLSelectElement;
    private _select2Element : any;

    templateHeaderGenerator(x: any) {
        if(x.viewModelData instanceof ViewModel){
            let newNode = ViewGenerator.GetNodeByTemplate(x.viewModelData,this.headerTemplate)
            return $(newNode);
        }else{
            return x.text;
        }
    }
    templateBodyGenerator(x: any) {
        if(x.viewModelData instanceof ViewModel){
            let newNode = ViewGenerator.GetNodeByTemplate(x.viewModelData,this.itemTemplate)
            return $(newNode);
        }else{
            return x.text;
        }
    }

    public onRenderCompleted() {
        this._selectElement = this.firstlevelElement.querySelector('select'); 
        

        this._select2Element = (<any>$(this._selectElement)).select2({
            multiple : true,
            width : '100%',
            dir:"rtl",
            templateResult : x=>this.templateBodyGenerator(x),
            templateSelection : x=>this.templateHeaderGenerator(x)
        });
        this._select2Element.on('change',x=>this.selectionChanged(x));

        MultiSelectComboBoxView.activeCombos.push({
            htmlElement : this._selectElement,
            select2Element : this._select2Element
        });
    }
    static destroy(select2Element){
        select2Element.off('change');
        select2Element.select2('destroy');
    }
    selectionChanged(x: any) {
        let selectedItems = (<any>$(this._selectElement)).select2('data');
        let ids = selectedItems.map(x=>x.id);
        let selectedViewModels = ids.map(x=>this.items.filter(q=>q.viewModelObjectId==x).at(0)).filter(x=>x!=null);
        this.selecteditems.update(...selectedViewModels);
    }

    itemsChanged(): void {
        if(this._select2Element && this.items){
            let data = this.items.map(x=>{
                return {
                    id : x.viewModelObjectId,
                    text : stringIsNullOrEmpty(this.searchpath) ? '' : x[this.searchpath],
                    viewModelData : x
                };
            })
            this._select2Element = (<any>$(this._selectElement)).select2({
                data : data,
                templateResult : x=>this.templateBodyGenerator(x),
                templateSelection : x=>this.templateHeaderGenerator(x)
            });
        }
    }
    private isTriggering : boolean=false;
    selecteditemsChanged(): void {
        if(this._select2Element && this.selecteditems){
            let selectedIds = this.selecteditems.map(x=>x.viewModelObjectId);
            this._select2Element.val(selectedIds);
            try{
                if(this.isTriggering==false){
                    this.isTriggering = true;
                    this._select2Element.trigger('change');
                }
            }finally{
                this.isTriggering = false;
            }
        }
    }
    doubleClick(e:MouseEvent){
        let elements = document.elementsFromPoint(e.x,e.y);
        let item = elements.filter(x=>x instanceof HTMLElement && x.classList.contains('select2-selection__choice')).at(0);
        if(item!=null){
            let header = item.querySelector('.header-template');
            if(header!=null){
                let viewModel = (<any>header).binderRelatedView.dataContext;
                this.selecteditems.update(...[viewModel]);
            }
        }
    }

    private itemTemplate : Node;
    private headerTemplate : Node;

    append(...nodes: (Node | string)[]): void{
        nodes.forEach(node=>{
            if(node instanceof HTMLElement && node.classList.contains("header-template")){
                this.headerTemplate = super.removeAsTemplate(node);
            }else if(node instanceof HTMLElement && node.classList.contains("template")){
                this.itemTemplate = super.removeAsTemplate(node);
            }else{
                this.firstlevelElement.append(node);
            }
        })
    }
}
